import { useState } from 'react';
import { setFeaturedMarketAnalysisPost } from '../../../api/marketAnalysisPostsApi';

const MarketAnalysisPostFeaturedEditor = ({ pageId, isFeatured, onFeaturedChange }) => {
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSetFeatured = async () => {
    setIsSaving(true);
    setError('');

    try {
      await setFeaturedMarketAnalysisPost(pageId);
      onFeaturedChange?.();
    } catch (err) {
      setError(err.message || 'Failed to update featured post.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="rounded-md border border-[#e4d9c8] bg-[#faf8f4] p-4">
      <p className="text-sm font-medium text-[#130705]">Featured post</p>
      <p className="mt-1 text-sm text-[#6b635c]">
        The featured post appears in the large hero card on the market analysis page.
      </p>
      {isFeatured ? (
        <p className="mt-3 text-[12px] font-medium uppercase tracking-[0.12em] text-[#8d7045]">
          This post is currently featured
        </p>
      ) : (
        <button
          type="button"
          onClick={handleSetFeatured}
          disabled={isSaving}
          className="mt-3 rounded-md border border-[#e4d9c8] bg-white px-4 py-2 text-sm font-medium text-[#130705] hover:bg-[#faf8f4] disabled:opacity-60"
        >
          {isSaving ? 'Updating…' : 'Set as featured post'}
        </button>
      )}
      {error ? <p className="mt-2 text-sm text-red-700">{error}</p> : null}
    </div>
  );
};

export default MarketAnalysisPostFeaturedEditor;
